import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { Lightning } from '@lightningjs/sdk';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { TRANSPARENT } from '../../tornado/utils/colors';
import { HEIGHT as SPECTRUM_HEIGHT, WIDTH as SPECTRUM_WIDTH } from './spectrum/bars.style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(PRIMARY, 0.1),
  text: makeThemeColor(PRIMARY),
  border: makeThemeColor(PRIMARY),
};

export const WIDTH = {
  [HD]: 152,
  [FULL_HD]: 224,
};

export const HEIGHT = {
  [HD]: 72,
  [FULL_HD]: 88,
};

export const PADDING = {
  [HD]: 12,
  [FULL_HD]: 16,
};

export const GAP = {
  [HD]: 24,
  [FULL_HD]: 24,
};

export const COVER_SIZE = {
  [HD]: 48,
  [FULL_HD]: 56,
};

export const BORDER = {
  [HD]: 2,
  [FULL_HD]: 4,
};

const DEFAULT_WIDTH = {
  [HD]: 304,
  [FULL_HD]: 416,
};

export const TRANSITION_CONFIG = { duration: 0.3 };

export const getExtraTitleFont = screenSize => getFont(FONT.BERLIN_1, screenSize);

export const getTitleFont = screenSize => getFont(FONT.MADRID_3, screenSize);

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => {
  const commonTextConfig = {
    textColor: colors.text[colorMode],
    textAlign: 'center',
    maxLines: 1,
    maxLinesSuffix: '...',
    verticalAlign: 'middle',
  };

  const extraTitleFont = getExtraTitleFont(screenSize);
  const titleFont = getTitleFont(screenSize);
  const textX = PADDING[screenSize] * 2 + COVER_SIZE[screenSize];
  const textWidth =
    DEFAULT_WIDTH[screenSize] -
    COVER_SIZE[screenSize] -
    PADDING[screenSize] * 3 -
    GAP[screenSize] -
    SPECTRUM_WIDTH[screenSize];

  return {
    h: HEIGHT[screenSize],
    Background: {
      w: value => value,
      h: HEIGHT[screenSize],
      color: colors.background[colorMode],
      alpha: 0,
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        stroke: 0,
        strokeColor: TRANSPARENT,
        radius: 4,
      },
    },
    Spectrum: {
      y: Math.round((HEIGHT[screenSize] - SPECTRUM_HEIGHT[screenSize]) / 2),
    },
    Cover: {
      alpha: 0,
      w: COVER_SIZE[screenSize],
      h: COVER_SIZE[screenSize],
      x: PADDING[screenSize],
      y: Math.round((HEIGHT[screenSize] - COVER_SIZE[screenSize]) / 2),
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: 4,
      },
    },
    ExtraTitle: {
      x: textX,
      y: PADDING[screenSize],
      w: textWidth,
      font: {
        ...extraTitleFont,
        ...commonTextConfig,
      },
    },
    Title: {
      x: textX,
      y: PADDING[screenSize] + extraTitleFont.lineHeight,
      w: textWidth,
      font: {
        ...titleFont,
        ...commonTextConfig,
      },
    },
  };
};

export const getFocusedStyle = ({ colorMode, screenSize }) => ({
  Background: {
    smooth: {
      'shader.strokeColor': colors.border[colorMode],
      'shader.stroke': BORDER[screenSize],
      radius: 4 + BORDER[screenSize],
    },
  },
});

export const getUnFocusedStyle = () => ({
  Background: {
    smooth: {
      'shader.strokeColor': TRANSPARENT,
      'shader.stroke': 0,
      radius: 4,
    },
  },
});
